import { CSSProperties } from "react";
import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const TextInputContainer = styled.div`
  padding: ${spacing.s}px;
  width: 100%;
  box-sizing: border-box;
  border-radius: ${constants.radius.view}px;
`;

export const TextInputComponent = styled.input`
  all: unset;
  width: 100%;
  align-content: stretch;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1em;
  font-variation-settings: "slnt" 0;
  color: ${({ theme }) => theme.input.text};
  &::placeholder {
    color: ${({ theme }) => theme.input.placeholder};
  }
`;

export const Container = styled.div`
  flex-grow: 1;
`;

export const LeftContainer = styled.div`
  margin-right: ${spacing.xs}px;
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    disabled: {
      opacity: 0.5,
    },
    textInputContainer: {
      backgroundColor: theme.input.background,
    },
    label: {
      color: theme.input.text,
    },
    error: {
      color: theme.input.error,
    },
    secondaryLabel: {
      width: "30%",
      flexShrink: 1,
    },
    secondaryInput: {
      textAlign: "right",
      flex: 1,
      minWidth: 0,
      marginLeft: spacing.s,
      padding: spacing.m,
    },
    inputRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      alignSelf: "stretch",
    },
    primaryInput: {
      flex: 1,
      minWidth: 0,
      width: "auto",
    },
  };

  return styles;
};
